export const EMPTY_FUNCTION = () => {};
